import React, { ReactElement, useState } from "react";
import { ChevronDown, ChevronUp, Menu02 } from "@untitled-ui/icons-react";
import { MobileNavMenuItem } from "./mobileNavMenuItem";
import * as Dialog from "@radix-ui/react-dialog";
import Link from "next/link";
import KunduzMobileLogo from "@icons/kunduzMobileIcon.svg";
import { eventBus } from "@kunduz/utility-common";
import styles from "./mobileNavMenu.module.scss";
import classNames from "classnames";

export const MobileNavMenu = (props: Props): ReactElement => {
  const [opened, setOpened] = useState(false);
  const [selectecMenu, setSelectedMenu] = useState<Props["menus"][0]>();

  const closeMenu = () => {
    setSelectedMenu(undefined);
    setOpened(false);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          zIndex: 1,
          alignItems: "center",
        }}
      >
        <div
          style={{
            listStyle: "none",
            display: "flex",
            justifyContent: "center",
            margin: "0 -16px",
            padding: "0",
            gap: "0px",
          }}
        >
          {props.menus?.map((menu, index) => (
            <div
              style={{
                position: "relative",
              }}
              key={index}
            >
              {menu.url ? (
                <Link className={styles.link} href={menu.url}>
                  {menu.title}
                </Link>
              ) : (
                <div
                  className={classNames(styles.triggerStyle, {
                    [styles.studentGradientTriggerStyle]:
                      menu.type === "blue_gradient",
                    [styles.tutorGradientTriggerStyle]:
                      menu.type === "green_gradient",
                  })}
                  onClick={() => {
                    if (opened) {
                      closeMenu();
                    } else {
                      setSelectedMenu(menu);
                      setOpened(true);
                    }
                  }}
                >
                  {menu.title}
                  <ChevronDown
                    style={{
                      transition: "transform 250ms ease",
                    }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <Dialog.Root open={opened}>
        <Dialog.Portal>
          <Dialog.Overlay className={styles.overlay} />
          <Dialog.Content
            className={styles.content}
            onOpenAutoFocus={(e) => e.preventDefault()}
          >
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingLeft: "16px",
                  height: "64px",
                  flexShrink: 0,
                  borderBottom: "1px solid #eaecf0",
                }}
              >
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  <button
                    onClick={() => {
                      eventBus.emit("hamburgerClicked");
                      closeMenu();
                    }}
                    className={styles.menuButton}
                  >
                    <Menu02 />
                  </button>
                  <Link href={props.lang == "tr" ? "/tr/" : "/"}>
                    <KunduzMobileLogo
                      style={{
                        height: "24px",
                        width: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </Link>
                </div>
                <div
                  className={classNames(styles.triggerStyle, {
                    [styles.studentGradientTriggerStyle]:
                      selectecMenu?.type === "blue_gradient",
                    [styles.tutorGradientTriggerStyle]:
                      selectecMenu?.type === "green_gradient",
                  })}
                  onClick={() => {
                    closeMenu();
                  }}
                >
                  {selectecMenu?.title}
                  <ChevronUp
                    style={{
                      transition: "transform 250ms ease",
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  padding: "16px",
                  overflowY: "scroll",
                }}
              >
                {selectecMenu?.items?.map((item, j) => (
                  <MobileNavMenuItem
                    key={j}
                    title={item.title}
                    icon={item.icon}
                    url={item.url}
                    badgeText={item.badgeText}
                    badgeColor={item.badgeColor}
                    onClick={() => {
                      item.onClick && item.onClick();
                      closeMenu();
                    }}
                  />
                ))}
              </div>
            </>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
};

interface Props {
  menus: {
    title: string;
    url?: string;
    type?: "blue_gradient" | "green_gradient";
    items?: {
      title: string;
      desc?: string;
      icon?: JSX.Element;
      url: string;
      badgeText?: string;
      badgeColor?: "green" | "blue" | "red" | "gray";
      onClick?: () => void;
    }[];
  }[];
  lang: "tr" | "en";
}
